// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rTvD6","lightboxBackdrop":"styles_lightboxBackdrop__WmU7U","lightboxInner":"styles_lightboxInner__uyx0s","placeholder":"styles_placeholder__0UAHG"};